<template>
  <el-dialog title="Pagar Comissão" :visible.sync="visibility" :before-close="fechar" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top">
      <el-col :span="10">
        <el-form-item label="Data de Pagamento">
          <el-input v-model="dataPagamento" v-mask="'##/##/####'"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="14">
        <el-form-item label="Corretor" style="width: 100%">
          <el-input
            v-if="!comissao.comissaoImobiliaria"
            v-model="pagamentoComissao.corretor.nome"
            style="width: 100%"
            readonly
          ></el-input>

          <el-input value="IMOBILIÁRIA" v-else readonly></el-input>
        </el-form-item>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="fechar">Fechar</el-button>
      <el-button @click="pagarComissao" type="primary">Pagar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Util from "../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    comissao: {
      corretor: {
        nome: ''
      }
    },
    pagamentoComissao: {
      corretor: {
        nome: ''
      }
    }
  },
  data() {
    return {
      dataPagamento: Util.hoje(),
    };
  },
  computed: {
    ...mapState("vendasStore", {
      venda(state) { return state.vendaSelecionada; },
      usuariosDisponiveis() { return state.usuariosDisponiveis; }
    })
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("vendasStore", [
      "pagarComissaoCorretor"
    ]),
    pagarComissao() {
      let payload = {
        id: this.pagamentoComissao.id,
        dataPagamento: this.dataPagamento,
        venda: { id: this.venda.id },
        comissao: { id: this.comissao.id },
      };

      this.showLoading();
      this.pagarComissaoCorretor(payload)
      .then(response => {
        this.hideLoading();
        switch (response.status) {
          case "SUCESSO":
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

